import React from 'react';
import { Link } from 'react-router-dom';
import useSeo from '../hooks/useSeo';
import './Pages.css';

function Office365CloudProductivity() {
  useSeo(
    'Office 365 & Cloud Productivity | Rev-Tech Services',
    'Rev-Tech helps businesses manage Office 365 and cloud productivity tools with secure administration and collaboration support.',
    {
      canonical: 'https://www.rev-technology.com/services/office-365-cloud-productivity'
    }
  );

  return (
    <div className="page">
      <h1>Office 365 & Cloud Productivity</h1>
      <section className="content-section">
        <p>
          Rev-Tech helps organizations manage and optimize Office 365 and cloud productivity tools so employees can collaborate efficiently
          and securely from anywhere.
        </p>
      </section>

      <section className="content-section">
        <h2>What&apos;s Included</h2>
        <ul className="values-list">
          <li><strong>Office 365 administration:</strong> User provisioning, licensing, and tenant management.</li>
          <li><strong>Cloud file sync:</strong> Managed access to cloud storage and file sharing.</li>
          <li><strong>Collaboration support:</strong> Teams, SharePoint, and email support for modern workflows.</li>
          <li><strong>Productivity enhancements:</strong> Optimized settings and training for employee success.</li>
        </ul>
      </section>

      <section className="content-section">
        <h2>Why it matters</h2>
        <p>
          Well-managed cloud productivity keeps your team connected and secure, while maximizing the value of your Microsoft 365 investment.
          Rev-Tech supports the tools your business relies on every day.
        </p>
      </section>

      <Link to="/services" className="cta-button">Back to Services</Link>
    </div>
  );
}

export default Office365CloudProductivity;
